import * as React from 'react';
import Panel from '../../../../theme/components/Panel';
import Table from '../../../../theme/components/table/Table';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import {Meses} from '../../../../utils/constants';
import {localNumber} from '../../../../utils/number-utils';
import DownloadIcon from 'mdi-react/DownloadIcon';
import {Button, Col, Row} from 'reactstrap';

interface AvanceAnualTableProps {
    data?: mirana.AvanceAnualList;
    handleDescargar: () => {};
}

class AvanceAnualTable extends React.PureComponent<AvanceAnualTableProps> {

    private get anhos() {
        const content = [] as any;
        const {data} = this.props;
        if (data && data.anhos) {
            data.anhos.forEach((anho, key) => {
                content.push(<th colSpan={2} key={`an-${key}`}>{anho}</th>)
            });
        }
        return content;
    }

    private get headers() {
        const content = [] as any;
        const {data} = this.props;
        if (data && data.anhos) {
            data.anhos.forEach((_, key) => {
                content.push(<th key={`a-${key}`}>Avance</th>);
                content.push(<th key={`s-${key}`}>Soles</th>);
            });
        }
        return content;
    }

    private row = (mes) => {
        const content = [] as any;

        const {data} = this.props;
        if (data && data.avances && data.avances.length > 0) {
            data.anhos.map((anho) => {
                const avances = data.avances.filter((av) => {
                    return av.mes === mes && Number(av.anho) === anho;
                });
                if (avances.length > 0) {
                    avances.forEach((av, key) => {
                        content.push(<td style={{textAlign: 'right'}}
                                         key={`${anho}-${mes}-v`}>{localNumber(av.volumen)}</td>);
                        content.push(<td style={{textAlign: 'right'}}
                                         key={`${anho}-${mes}-m`}>{localNumber(av.monto)}</td>);
                    });
                } else {
                    content.push(<td key={`${anho}-${mes}-v`}/>);
                    content.push(<td key={`${anho}-${mes}-m`}/>);
                }
            });
        }
        return content;
    };

    private get rows() {
        const content = [] as any;

        const {data} = this.props;
        if (data && data.avances && data.avances.length > 0) {
            Meses.forEach((mes, key) => {
                content.push(<tr key={`c-${key}`}>
                    <td key={`d-${key}`}>{mes}</td>
                    {this.row(mes)}
                </tr>);
            });
            content.push(<tr key='footer-row'>
                <th>TOTAL</th>
                {data.anhos.map((anho) => {
                    const avances = data.avances.filter((av) => {
                        return Number(av.anho) === anho;
                    });
                    const initialValue = 0;
                    const sumVolumen = avances.reduce((initial, el) => el.volumen ? initial + el.volumen : initial, initialValue);
                    const sumMonto = avances.reduce((initial, el) => el.monto ? initial + el.monto : initial, initialValue);
                    return <React.Fragment key={`z-${anho}`}>
                        <th style={{textAlign: 'right'}}>{localNumber(sumVolumen)}</th>
                        <th style={{textAlign: 'right'}}>{localNumber(sumMonto)}</th>
                    </React.Fragment>
                })}
            </tr>)
        }


        return content;
    }

    public render() {
        return (
            <Panel xs={12} md={12} divider={true} title='Resultados'>
                <Row>
                    <Col md={{size: 1, offset: 11}} lg={{size: 1, offset: 11}}>
                        <Button outline={true} className='icon icon--only' onClick={this.props.handleDescargar}
                                disabled={!this.props.data}><DownloadIcon/></Button>
                    </Col>
                </Row>
                {this.props.data ? <Table striped={true} responsive={true}>
                    <thead>
                    <tr>
                        <th/>
                        {this.anhos}
                    </tr>
                    <tr>
                        <th/>
                        {this.headers}
                    </tr>
                    </thead>
                    <tbody>
                    {this.rows}
                    </tbody>
                </Table> : null}
            </Panel>
        )
    }
}

export default AvanceAnualTable;



// WEBPACK FOOTER //
// ./src/components/pages/avance/anual/avance-anual-table.tsx